// extracted by mini-css-extract-plugin
export default {"p_tye":"_6541ccc93b","slcted":"_0d6e14b30f","slc_color":"a567370829","item_p":"b63beb107f","r0":"_531d062624"};